var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"lazy":"","width":"750"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('image-container',{attrs:{"images":_vm.images,"imageMonths":_vm.imageMonths,"modal":true},on:{"selected":_vm.onImageSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }